const e = new TextEncoder(), o = new TextDecoder();
export {
  o as decoder,
  e as encoder
};
